export const ROUTES_VARIANT = {
  VERIFY_OTP: "verifyOTP",
  FINISH: "finish",
  PROCESS: "process",
  NAME_MATCH_TESTER: "name-match-tester",
  VERIFIED_KYC_USERS: "verified-kyc-users",
};

/** Full path for the SSO-secured name match tester under the admin console */
export const NAME_MATCH_TESTER_PATH = `/${ROUTES_VARIANT.NAME_MATCH_TESTER}`;

